import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import InitiativeDefaultThumbnail from 'src/sites/kits/Initiative/components/DefaultThumbnail'
import ObjectPrivacyBadge from 'src/sites/kits/Object/components/PrivacyBadge'
import { Title } from 'src/sites/kits/UI'

const InitiativeListItemDetailsCard = ({
   coverMedia,
   iconName,
   linkTo,
   meta,
   name,
   privacy,
   subtitle,
   summary,
   thumbnailHeight,
   thumbnailSpacing,
   thumbnailWidth
}) => (
   <Link to={linkTo}>
      <View display="flex" width="100%">
         <View
            flex="0 0 auto"
            width={thumbnailWidth}
            height={thumbnailHeight}
            backgroundColor="#eee"
            backgroundImage={coverMedia && `url(${coverMedia?.file.thumbnailUrlW480})`}
            backgroundSize="cover"
            backgroundPosition="center center"
            backgroundRepeat="no-repeat"
            borderRadius="6px"
            style={{ overflow: 'hidden' }}>
            {!coverMedia && (
               <InitiativeDefaultThumbnail
                  highlightColor="#eee"
                  iconColor="#ccc"
                  iconName={iconName}
                  iconSize="24px"
               />
            )}
         </View>
         <View
            flex="0 0 auto"
            paddingLeft={thumbnailSpacing}
            width="calc(100% - 60px)">
            <Title
               size="xs"
               style={{ wordWrap: 'break-word' }}>
               {name}
            </Title>
            {(subtitle || summary) && (
               <View
                  margin="2px 0px"
                  maxHeight="60px[a-d] 60px[e-f]"
                  style={{
                     overflow: 'hidden',
                     textOverflow: 'ellipsis',
                     wordBreak: 'break-word'
                  }}>
                  <div style={{ color: 'var(--bodyTextColor)' }}>
                     {subtitle}
                     {!subtitle && <div dangerouslySetInnerHTML={{ __html: summary }} />}
                  </div>
               </View>
            )}
            {meta?.length > 0 && (
               <View display="flex">
                  <ObjectPrivacyBadge privacy={privacy} />
                  <div className="ui-meta-text">
                     {meta.map((item, index) => (
                        <React.Fragment key={item}>
                           {index !== 0 ? <>&nbsp;&#183;&nbsp;</> : ''}
                           {item}
                        </React.Fragment>
                     ))}
                  </div>
               </View>
            )}
         </View>
      </View>
   </Link>
)

InitiativeListItemDetailsCard.propTypes = {
   coverMedia: PropTypes.object,
   iconName: PropTypes.string,
   linkTo: PropTypes.string.isRequired,
   meta: PropTypes.arrayOf(PropTypes.string),
   name: PropTypes.string.isRequired,
   privacy: PropTypes.string,
   subtitle: PropTypes.string,
   summary: PropTypes.string,
   thumbnailHeight: PropTypes.string,
   thumbnailSpacing: PropTypes.string,
   thumbnailWidth: PropTypes.string
}

InitiativeListItemDetailsCard.defaultProps = {
   coverMedia: undefined,
   iconName: undefined,
   meta: undefined,
   privacy: undefined,
   subtitle: undefined,
   summary: undefined,
   thumbnailHeight: '48px[a-d] 64px[e-f]',
   thumbnailSpacing: '24px',
   thumbnailWidth: '48px[a-d] 64px[e-f]'
}

export default InitiativeListItemDetailsCard
